import { render } from "./ServicesContent.vue?vue&type=template&id=58be18cb"
import script from "./ServicesContent.vue?vue&type=script&lang=js"
export * from "./ServicesContent.vue?vue&type=script&lang=js"

import "./ServicesContent.vue?vue&type=style&index=0&id=58be18cb&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__